import MesureDetailController from './mesure.detail.controller';

export default {
    template: require('./mesure.detail.html'),
    controller: MesureDetailController
};
